import { render } from "./gallery_video.vue?vue&type=template&id=9c90c196&scoped=true"
import script from "./gallery_video.vue?vue&type=script&lang=js"
export * from "./gallery_video.vue?vue&type=script&lang=js"

import "./gallery_video.vue?vue&type=style&index=0&id=9c90c196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c90c196"]])

export default __exports__